import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', fontFamily: 'monospace', color: '#e5e5e5', background: '#1a1a1a', minHeight: '100dvh' }}>
          <h1 style={{ color: '#f87171', marginBottom: '1rem' }}>Application Error</h1>
          <p style={{ marginBottom: '0.5rem' }}>Something went wrong during initialization.</p>
          <pre style={{ whiteSpace: 'pre-wrap', fontSize: '0.8rem', color: '#fbbf24' }}>
            {this.state.error?.message}
          </pre>
          <p style={{ marginTop: '1rem', color: '#a3a3a3', fontSize: '0.85rem' }}>
            Check the browser console for details. If auth fails, ensure VITE_OKTA_ISSUER and VITE_OKTA_CLIENT_ID are set at build time.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}
